module.exports = __webpack_public_path__ + "img/6-4.0e588e9f.png";